import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AccessQuestionComponent } from './access-question/access-question.component';

const routes: Routes = [
  {
      path: ':congress_id/session/:session_group_id',
      component: AccessQuestionComponent,
    },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AccessQuestionRoutingModule { }
